/* eslint-disable */
export default {
  from: '從',
  to: '撥給',
  enterNameOrNumber: '輸入號碼或姓名...',
  typeMessage: '輸入訊息...',
  send: '傳送',
  emoji: '表情符號',
} as const;

// @key: @#@"from"@#@ @source: @#@"From"@#@
// @key: @#@"to"@#@ @source: @#@"To"@#@
// @key: @#@"enterNameOrNumber"@#@ @source: @#@"Enter Number or Name..."@#@
// @key: @#@"typeMessage"@#@ @source: @#@"Type message..."@#@
// @key: @#@"send"@#@ @source: @#@"Send"@#@
// @key: @#@"emoji"@#@ @source: @#@"Emoji"@#@
